<template>
    <div class="conferenceIndex">
        <!-- 滚动文字、开幕时间 -->
        <div class="scroll section">
            <div class="scroll_left">
                <div class="scroll_left_img">
                    <img src="../assets/images/conference/con_1.png" alt="">
                </div>
                <div class="scrollingWords">
                    <div class="scrollingWords_text">
                        {{ scrollArticleInfo.title }}
                    </div>
                </div>
            </div>
            <div class="scroll_right">
                <div class="scroll_right_img">
                    <img src="../assets/images/conference/con_2.png" alt="">
                </div>
                <div class="scroll_right_right">
                    距离大会开幕还有
                    <span>{{countDownDay}}</span>
                    天
                </div>
            </div>
        </div>
        <!-- 大会现场，大会简介 -->
        <div class="meeting">
            <div class="meeting_box section">
                <div class="meeting_item meeting_left">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">会议现场</div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(101,meetingVenueId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="meeting_left_bottom">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" @click="goItemDetail(101,item)" v-for="item in meetingVenue" :key="item.id">
                                    <div class="meeting_left_bottom_img">
                                        <img v-if="item.picture" :src="baseUrl+item.picture" alt="">
                                        <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                    </div>
                                    <div class="meeting_left_bottom_mask">
                                        <div class="meeting_left_bottom_mask_name">{{item.title}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="pagination_box">
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="meeting_item meeting_right">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">大会简介</div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(101,meetingIntroId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="meeting_right_bottom">
                        <div class="meeting_right_bottom_profile">{{meetingIntro&&meetingIntro.length>0?meetingIntro[0].profile:''}}</div>
                        <div class="meeting_right_bottom_box">
                            <div class="meeting_right_bottom_box_item" @click="goWeb(item)" v-for="(item,index) in meetingIntroList" :key="index">
                                <div class="meeting_right_bottom_box_item_top">
                                    <img :src="item.imgSrc" alt="">
                                </div>
                                <div class="meeting_right_bottom_box_item_bottom">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 大会聚焦 -->
        <div class="focus">
            <div class="focus_box section">
                <div class="meeting_item_top">
                    <div class="meeting_item_top_left">
                        <div class="meeting_item_top_left_line"></div>
                        <div class="meeting_item_top_left_text">大会聚焦</div>
                    </div>
                    <div class="meeting_item_top_right">
                        <div class="meeting_item_top_right_line"></div>
                        <div class="meeting_item_top_right_text" @click="goMore(101,meetingFocusId)">查看更多</div>
                        <div class="meeting_item_top_right_img">
                            <img src="../assets/images/conference/arrow_right.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="focus_bottom">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="item in meetingFocus" :key="item.id">
                                <div class="focus_item_top">{{item.title}}</div>
                                <div class="focus_item_time">发布时间：{{item.publishTime?handleTime(item.publishTime):''}}</div>
                                <div class="focus_item_profile">{{item.profile}}</div>
                                <div class="focus_item_more" @click="goItemDetail(101,item)">查看详情 ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 大会笔记，大会通知 -->
        <div class="notice">
            <div class="meeting_box section">
                <div class="meeting_item meeting_left">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">大会笔记</div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(103,meetingNoteId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="notice_left_bottom">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="item in meetingNote" :key="item.id">
                                    <div class="focus_item_top">
                                        <div class="focus_item_top_title">{{item.title}}</div>
                                        <div class="focus_item_top_line"></div>
                                    </div>
                                    <div class="focus_item_profile">{{item.profile}}</div>
                                    <div class="focus_item_time">
                                        <div class="focus_item_time_left">{{item.publishTime?handleTime(item.publishTime):''}}</div>
                                        <div class="focus_item_time_right" @click="goItemDetail(103,item)">
                                            <img src="../assets/images/conference/more.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="meeting_item meeting_right">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">大会通知</div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(101,meetingNoticeId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="meeting_right_bottom">
                        <div class="meeting_right_bottom_box">
                            <div class="meeting_right_bottom_box_item" @click="goItemDetail(101,item)" v-for="(item,index) in meetingNotice" :key="index">
                                <div class="meeting_right_bottom_box_item_left">
                                    <div class="meeting_right_bottom_box_item_left_top">{{item.publishTime?handleGetTime('day',item.publishTime):''}}</div>
                                    <div class="meeting_right_bottom_box_item_left_bottom">{{item.publishTime?handleGetTime('yearMonth',item.publishTime):''}}</div>
                                </div>
                                <div class="meeting_right_bottom_box_item_right">{{item.title}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 精彩回顾，组织结构，大会奖项 -->
        <div class="middle">
            <div class="middle_box section">
                <div class="middle_item" :style="{ backgroundImage: 'url(' + item.imgSrc + ')' }" v-for="(item,index) in middleData" :key="index">
                    <div class="middle_item_top">{{item.name}}</div>
                    <div class="middle_item_line"></div>
                    <div class="middle_item_profile">{{item.profile}}</div>
                    <div class="middle_item_more" @click="goMore(item.type,item.id)">
                        了解详情
                        <img v-if="index==1" src="../assets/images/conference/more.png" alt="">
                        <img v-else src="../assets/images/conference/more_white.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!-- 历届大会院士嘉宾 -->
        <div class="guest">
            <div class="guest_box section">
                <div class="guest_top">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">历届大会院士嘉宾</div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(102,guestId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="guest_bottom">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" @click="goItemDetail(102,item)" v-for="item in guest" :key="item.id">
                                <div class="guest_img">
                                    <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                    <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                </div>
                                <div class="guest_img_box">
                                    <div class="guest_img_box_box guest_img_box_box_bgc">
                                        <div class="guest_img_box_box_top">
                                            <div class="guest_img_box_box_top_left">{{item.title?handleTitle('名称',item.title):''}}</div>
                                            <div class="guest_img_box_box_top_right">{{item.title?handleTitle('职称',item.title):''}}</div>
                                        </div>
                                        <div class="guest_img_box_box_bottom">{{item.profile}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 本届大会演讲专家,历届大会演讲专家 -->
        <div class="guest expert">
            <div class="guest_box section">
                <div class="guest_top">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_text" :class="showExpert==1?'meeting_item_top_left_text_active':''" style="margin-right:50px;" @click="handleShowExpert(1)">
                                本届大会演讲专家
                                <div class="meeting_item_top_left_text_line"></div>
                            </div>
                            <div class="meeting_item_top_left_text" :class="showExpert==2?'meeting_item_top_left_text_active':''" @click="handleShowExpert(2)">
                                历届大会演讲专家
                                <div class="meeting_item_top_left_text_line"></div>
                            </div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(102,showExpert==1?currentExpertId:historyExpertId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="current_expert">
                    <div class="swiper-container" v-if="showExpert==1">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" @click="goItemDetail(102,item)" v-for="item in currentExpert" :key="item.id">
                                <div class="guest_img">
                                    <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                    <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                </div>
                                <div class="guest_img_box">
                                    <div class="guest_img_box_box">
                                        <div class="guest_img_box_box_top">
                                            <div class="guest_img_box_box_top_left">{{item.title?handleTitle('名称',item.title):''}}</div>
                                            <div class="guest_img_box_box_top_right">{{item.title?handleTitle('职称',item.title):''}}</div>
                                        </div>
                                        <div class="guest_img_box_box_bottom">{{item.profile}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history_expert">
                    <div class="swiper-container" v-if="showExpert==2">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" @click="goItemDetail(102,item)" v-for="item in historyExpert" :key="item.id">
                                <div class="guest_img">
                                    <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                    <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                </div>
                                <div class="guest_img_box">
                                    <div class="guest_img_box_box">
                                        <div class="guest_img_box_box_top">
                                            <div class="guest_img_box_box_top_left">{{item.title?handleTitle('名称',item.title):''}}</div>
                                            <div class="guest_img_box_box_top_right">{{item.title?handleTitle('职称',item.title):''}}</div>
                                        </div>
                                        <div class="guest_img_box_box_bottom">{{item.profile}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 历届赞助商 -->
        <div class="guest sponsor">
            <div class="guest_box section">
                <div class="guest_top">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">
                                <div class="meeting_item_top_left_text_left">历届赞助商</div>
                                <div class="meeting_item_top_left_text_right">（排名不分先后）</div>
                            </div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(106,sponsorId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sponsor_bottom">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" @click="goItemDetail(106,item)" v-for="item in sponsor" :key="item.id">
                                <div class="sponsor_img">
                                    <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                    <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 合作媒体 -->
        <div class="guest media">
            <div class="guest_box section">
                <div class="guest_top">
                    <div class="meeting_item_top">
                        <div class="meeting_item_top_left">
                            <div class="meeting_item_top_left_line"></div>
                            <div class="meeting_item_top_left_text">
                                <div class="meeting_item_top_left_text_left">合作媒体</div>
                                <div class="meeting_item_top_left_text_right">（排名不分先后）</div>
                            </div>
                        </div>
                        <div class="meeting_item_top_right">
                            <div class="meeting_item_top_right_line"></div>
                            <div class="meeting_item_top_right_text" @click="goMore(106,mediaId)">查看更多</div>
                            <div class="meeting_item_top_right_img">
                                <img src="../assets/images/conference/arrow_right.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media_bottom">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" @click="goItemDetail(106,item)" v-for="item in media" :key="item.id">
                                <div class="media_img">
                                    <img v-if="item&&item.picture" :src="baseUrl+item.picture" alt="">
                                    <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper'
import mobileKJudge from '../untils/mobile-judge'
import { getConferenceConfig,getScrollArticleList,newsTypeList,newsList } from '../untils/common-api'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            scrollArticleInfo: { // 滚动文章信息
                title: '这是滚动信息这是滚动信息这是滚动信息',
                type: '',
                category: '',
                id: ''
            },
            countDownDay: 0, // 倒数日期
            // 大会现场
            meetingVenueId:null,
            meetingVenue:[],
            // 大会简介
            meetingIntroId:null,
            meetingIntro:[],
            meetingIntroList:[
                {
                    id:1,
                    name:'我要参会',
                    imgSrc:require('../assets/images/conference/meeting_intro_1.png'),
                    link:''
                },
                {
                    id:2,
                    name:'我要参展',
                    imgSrc:require('../assets/images/conference/meeting_intro_2.png'),
                    link:''
                },
                {
                    id:3,
                    name:'线上展览',
                    imgSrc:require('../assets/images/conference/meeting_intro_3.png'),
                    link:''
                },
            ],
            // 大会聚焦
            meetingFocusId:null,
            meetingFocus:[],
            // 大会笔记
            meetingNoteId:null,
            meetingNote:[],
            // 会议通知
            meetingNoticeId:null,
            meetingNotice:[],
            // 精彩回顾，组织架构，大会奖项
            middleData:[
                {
                    id:null,
                    type:101,
                    name:'精彩回顾',
                    imgSrc:require('../assets/images/conference/con_item1_bgc.png'),
                    profile:'回望大会的每一个精彩片段，凝聚同行伙伴的智慧与热情，蓄力再启新征程。'
                },
                {
                    id:null,
                    type:101,
                    name:'组织架构',
                    imgSrc:require('../assets/images/conference/con_item2_bgc.png'),
                    profile:'清晰架构筑牢发展根基，高效协同驱动企业前行以科学组织体系赋能每一步跨越。'
                },
                {
                    id:null,
                    type:105,
                    name:'大会奖项',
                    imgSrc:require('../assets/images/conference/con_item3_bgc.png'),
                    profile:'深耕者获嘉奖，坚守者得荣光，这场大会的高光时刻，属于每一位全力以赴的追梦人。'
                }
            ],
            // 历届大会院士嘉宾
            guestId:null,
            guest:[],
            // 本届大会演讲专家
            currentExpertId:null,
            currentExpert:[],
            // 历届大会演讲专家
            showExpert:1,
            historyExpertId:null,
            historyExpert:[],
            // 历届赞助商,
            sponsorId:null,
            sponsor:[],
            // 合作媒体
            mediaId:null,
            media:[],
        }
    },
    computed: {
        isMobile() {
            return mobileKJudge()
        },
    },
    mounted() {
    },
    created() {
        this.getConferenceConfigData()
        // 大会介绍
        this.getMeetingIntroCategory(101)
        // 大会笔记
        this.getMeetingNoteCategory(103)
        // 嘉宾专家
        this.getGuestCategory(102)
        // 同期活动
        this.getActivityCategory(105)
        // 赞助机会
        this.getSponsorshipCategory(106)
        this.getScrollArticlePage()
    },
    methods:{
        // 获取滚动文章列表
        async getScrollArticlePage() {
            const { data: res } = await getScrollArticleList()
            if (!res.length) return
            this.scrollArticleInfo.title = res[0].title
            this.scrollArticleInfo.category = res[0].categoryId
            this.scrollArticleInfo.id = res[0].id
            // this.categoryList.map(item => {
            //     item.children.map(item2 => {
            //         if (item2.id == res[0].categoryId) {
            //             this.scrollArticleInfo.type = item2.parentId
            //         }
            //     })
            // })
            this.$nextTick(() => {
                this.initScrollingWords()
            })
        },
        // 初始化滚动文字
        initScrollingWords() {
            let word = document.querySelector('.scrollingWords .scrollingWords_text')
            let wordBox = document.querySelector('.scrollingWords')
            let wordLeft = wordBox.offsetWidth
            let worderTimer = setInterval(() => {
                if (word.offsetLeft < 0 && Math.abs(word.offsetLeft) >= word.offsetWidth) {
                    wordLeft = wordBox.offsetWidth
                    word.style.left = wordBox.offsetWidth + 'px'
                } else {
                    word.style.left = (wordLeft -= 1) + 'px'
                }
            }, 10)
            document.querySelector('.scrollingWords').onmouseover = function() {
                clearInterval(worderTimer)
            }
            document.querySelector('.scrollingWords').onmouseout = function() {
                worderTimer = setInterval(() => {
                    if (word.offsetLeft < 0 && Math.abs(word.offsetLeft) >= word.offsetWidth) {
                        wordLeft = wordBox.offsetWidth
                        word.style.left = wordBox.offsetWidth + 'px'
                    } else {
                        word.style.left = (wordLeft -= 1) + 'px'
                    }
                }, 10)
            }
        },
        // 获取大会配置
        async getConferenceConfigData() {
            const { data: res } = await getConferenceConfig()
            this.getCountDown(res.openDate)
            if(res.linkList.length>0) {
                // 双重for循环找到name一致的赋值link
                for(let i=0;i<this.meetingIntroList.length;i++) {
                    for(let j=0;j<res.linkList.length;j++) {
                        if(this.meetingIntroList[i].name == res.linkList[j].name) {
                            this.meetingIntroList[i].link = res.linkList[j].url
                        }
                    }
                }
            }
            // this.linkList = res.linkList.slice(0, 4)
        },
        goWeb(item) {
            if(item.link) {
                // 打开新页面
                window.open(item.link, '_blank');
            }
        },
        // 获取倒数日期
        getCountDown(date) {
            if(date) {
                let nowTime = new Date().getTime()
                let newTime = new Date(date).getTime()
                if (nowTime >= newTime) return this.countDownDay = 0
                this.countDownDay = parseInt((newTime - nowTime)/(1000 * 60 * 60 * 24))
            }
        },
        async getMeetingIntroCategory(type) {
            const res  = await newsTypeList(
                {
                    model:type,
                    lang:1
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            if(res.data.records.length > 0) {
                let list = res.data.records
                // 在list中找到item.typeName为会议现场或者大会简介的
                let meetingVenue = list.find(item => item.typeName == '会议现场'||item.typeName == '大会现场')
                let meetingIntro = list.find(item => item.typeName == '大会简介')
                let meetingFocus = list.find(item => item.typeName == '大会聚焦')
                let meetingNotice = list.find(item => item.typeName == '大会通知'||item.typeName == '会议通知')
                let retrospect = list.find(item => item.typeName == '精彩回顾')
                let organization = list.find(item => item.typeName == '组织架构'||item.typeName =='组织机构' )
                if(meetingVenue) {
                    this.meetingVenueId = meetingVenue.id
                    this.getMeetingVenuePage(type,meetingVenue.id)
                }
                if(meetingIntro) {
                    this.meetingIntroId = meetingIntro.id
                    this.getMeetingIntroPage(type,meetingIntro.id)
                }
                if(meetingFocus) {
                    this.meetingFocusId = meetingFocus.id
                    this.getMeetingFocusPage(type,meetingFocus.id)
                }
                if(meetingNotice) {
                    this.meetingNoticeId = meetingNotice.id
                    this.getMeetingNoticePage(type,meetingNotice.id)
                }
                if(retrospect) {
                    this.middleData[0].id = retrospect.id
                }
                if(organization) {
                    this.middleData[1].id = organization.id
                }
            }
        },
        // 会议现场
        async getMeetingVenuePage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.meetingVenue = res.data.records
                if(this.meetingVenue.length>0) {
                    this.$nextTick(()=>{
                        this.initMeetingVenueSwiper()
                    })
                }
            }
        },
        // 初始化轮播图
        initMeetingVenueSwiper() {
            let venueSwiper =  new Swiper('.meeting_left_bottom .swiper-container', {
                autoplay: 3000,
                speed: 1000,
                loop: true,
                autoplayDisableOnInteraction: false,
                observer: true,
                pagination : '.meeting_left_bottom .swiper-pagination',
                paginationClickable: true,
            })
            //鼠标覆盖停止自动切换
            venueSwiper.container[0].onmouseover=function(){
                venueSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            venueSwiper.container[0].onmouseout=function(){
                venueSwiper.startAutoplay();
            }
        },
        // 大会简介
        async getMeetingIntroPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.meetingIntro = res.data.records
            }
        },
        // 大会聚焦
        async getMeetingFocusPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.meetingFocus = res.data.records
                if(this.meetingFocus.length>0) {
                    this.$nextTick(()=>{
                    this.initMeetingFocusSwiper()
                    })
                }
            }
        },
        // 初始化轮播图
        initMeetingFocusSwiper() {
            let focusSwiper =  new Swiper('.focus_bottom .swiper-container', {
                slidesPerView: this.isMobile ? 2 : 3,
                spaceBetween: this.isMobile ? 10 : 30,
                autoplay: 3000,
                speed: 1000,
                loop: this.isMobile ? this.meetingFocus.length > 2 ? true : false:this.meetingFocus.length > 3 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
                pauseOnMouseEnter: true,
            })
            //鼠标覆盖停止自动切换
            focusSwiper.container[0].onmouseover=function(){
                focusSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            focusSwiper.container[0].onmouseout=function(){
                focusSwiper.startAutoplay();
            }
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'.'+month+'.'+day
                return timeStr;
            }
        },
        async getMeetingNoteCategory(type) {
            const res  = await newsTypeList(
                {
                    model:type,
                    lang:1
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            if(res.data.records.length > 0) {
                let list = res.data.records
                let meetingNote = list.find(item => item.typeName == '大会笔记')
                if(meetingNote) {
                    this.meetingNoteId = meetingNote.id
                    this.getMeetingNotePage(type,meetingNote.id)
                }
            }
        },
        // 大会笔记
        async getMeetingNotePage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.meetingNote = res.data.records
                if(this.meetingNote.length>0) {
                    this.$nextTick(()=>{
                        this.initMeetingNoteSwiper()
                    })
                }
            }
        },
        initMeetingNoteSwiper() {
            let noteSwiper =  new Swiper('.notice_left_bottom .swiper-container', {
                slidesPerView: this.isMobile ? 2 : 3,
                spaceBetween: this.isMobile ? 10 : 20,
                autoplay: 3000,
                speed: 1000,
                loop: this.isMobile ? this.meetingNote.length > 2 ? true : false:this.meetingNote.length > 3 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
                pauseOnMouseEnter: true,
            })
            //鼠标覆盖停止自动切换
            noteSwiper.container[0].onmouseover=function(){
                noteSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            noteSwiper.container[0].onmouseout=function(){
                noteSwiper.startAutoplay();
            }
        },
        // 大会通知
        async getMeetingNoticePage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:3,
                    lang:1
                }
            )
            if(res.code==1) {
                this.meetingNotice = res.data.records
            }
        },
        handleGetTime(type,time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                if(type=='day') {
                    let timeStr = day
                    return timeStr;
                } else {
                    let timeStr = year+'-'+month
                    return timeStr;
                }
            }
        },
        async getActivityCategory(type) {
            const res  = await newsTypeList(
                {
                    model:type,
                    lang:1
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            if(res.data.records.length > 0) {
                let list = res.data.records
                let award = list.find(item => item.typeName == '大会奖项')
                if(award) {
                    this.middleData[2].id = award.id
                }
            }
        },
        // 嘉宾专家
        async getGuestCategory(type) {
            const res  = await newsTypeList(
                {
                    model:type,
                    lang:1
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            if(res.data.records.length > 0) {
                let list = res.data.records
                let guest = list.find(item => item.typeName == '历届大会院士嘉宾')
                let currentExpert = list.find(item => item.typeName == '本届大会演讲专家')
                let historyExpert = list.find(item => item.typeName == '历届大会演讲专家')
                if(guest) {
                    this.guestId = guest.id
                    this.getGuestPage(type,guest.id)
                }
                if(currentExpert) {
                    this.currentExpertId = currentExpert.id
                    this.getCurrentExpertPage(type,currentExpert.id)
                }
                if(historyExpert) {
                    this.historyExpertId = historyExpert.id
                    this.getHistoryExpertPage(type,historyExpert.id)
                }
            }
        },
        // 历届大会院士嘉宾
        async getGuestPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.guest = res.data.records
                if(this.guest.length >0) {
                    this.$nextTick(()=>{
                        this.initGuestSwiper()
                    })
                }
            }
        },
        initGuestSwiper() {
            let guestSwiper =  new Swiper('.guest_bottom .swiper-container', {
                slidesPerView: this.isMobile ? 2 : 5,
                spaceBetween: this.isMobile ? 10 : 20,
                autoplay: 3000,
                speed: 1000,
                loop: this.isMobile? this.guest.length > 2 ? true : false:this.guest.length > 5 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
                pauseOnMouseEnter: true,
            })
            //鼠标覆盖停止自动切换
            guestSwiper.container[0].onmouseover=function(){
                guestSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            guestSwiper.container[0].onmouseout=function(){
                guestSwiper.startAutoplay();
            }
        },
        handleTitle(name,title) {
            if(title) {
                let parts = title.split('-');
                let names = parts[0];  // '嘉宾4'
                let job = parts[1];   // '中国科学院院士'
                if(name=='名称') {
                    return names
                } else {
                    return job
                }
            }
        },
        // 本届大会演讲专家
        async getCurrentExpertPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.currentExpert = res.data.records
                if(this.currentExpert.length >0) {
                    this.$nextTick(()=>{
                        this.initCurrentExpertSwiper()
                    })
                }
            }
        },
        initCurrentExpertSwiper() {
            let currentExpertSwiper =  new Swiper('.current_expert .swiper-container', {
                slidesPerView: this.isMobile ? 2 : 5,
                spaceBetween: this.isMobile ? 10 : 20,
                autoplay: 3000,
                speed: 1000,
                loop: this.isMobile? this.currentExpert.length > 2 ? true : false:this.currentExpert.length > 5 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
                pauseOnMouseEnter: true,
            })
            //鼠标覆盖停止自动切换
            currentExpertSwiper.container[0].onmouseover=function(){
                currentExpertSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            currentExpertSwiper.container[0].onmouseout=function(){
                currentExpertSwiper.startAutoplay();
            }
        },
        // 历届大会演讲专家
        async getHistoryExpertPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.historyExpert = res.data.records
            }
        },
        initHistoryExpertSwiper() {
            let historyExpertSwiper =  new Swiper('.history_expert .swiper-container', {
                slidesPerView: this.isMobile ? 2 : 5,
                spaceBetween: this.isMobile ? 10 : 20,
                autoplay: 3000,
                speed: 1000,
                loop: this.isMobile? this.historyExpert.length > 2 ? true : false:this.historyExpert.length > 5 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
                pauseOnMouseEnter: true,
            })
            //鼠标覆盖停止自动切换
            historyExpertSwiper.container[0].onmouseover=function(){
                historyExpertSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            historyExpertSwiper.container[0].onmouseout=function(){
                historyExpertSwiper.startAutoplay();
            }
        },
        handleShowExpert(num) {
            this.showExpert = num
            if(num==1) {
                if(this.currentExpert.length>0) {
                    this.$nextTick(()=>{
                        this.initCurrentExpertSwiper()
                    })
                }
            } else {
                if(this.historyExpert.length>0) {
                    this.$nextTick(()=>{
                        this.initHistoryExpertSwiper()
                    })
                }
            }
        },
        // 赞助机会
        async getSponsorshipCategory(type) {
            const res  = await newsTypeList(
                {
                    model:type,
                    lang:1
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            if(res.data.records.length > 0) {
                let list = res.data.records
                let sponsor = list.find(item => item.typeName == '历届赞助商')
                let media = list.find(item => item.typeName == '合作媒体')
                if(sponsor) {
                    this.sponsorId = sponsor.id
                    this.getSponsorshipPage(type,sponsor.id)
                }
                if(media) {
                    this.mediaId = media.id
                    this.getMediaPage(type,media.id)
                }
            }
        },
        // 历届赞助商
        async getSponsorshipPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.sponsor = res.data.records
                if(this.sponsor.length >0) {
                    this.initSponsorSwiper()
                }
            }
        },
        initSponsorSwiper() {
            let sponsorSwiper =  new Swiper('.sponsor_bottom .swiper-container', {
                spaceBetween: this.isMobile ? 10 : 20,
                slidesPerView: this.isMobile ? 3 : 6,
                slidesPerColumn: 3,
                slidesPerColumnFill: 'row',
                autoplay: 3000,
                speed: 1000,
                loop: this.isMobile ? this.historyExpert.length > 9 ? true : false:this.historyExpert.length > 18 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
            })
            //鼠标覆盖停止自动切换
            sponsorSwiper.container[0].onmouseover=function(){
                sponsorSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            sponsorSwiper.container[0].onmouseout=function(){
                sponsorSwiper.startAutoplay();
            }
        },
        // 合作媒体
        async getMediaPage(type,id) {
            const res = await newsList(
                {
                    model:type,
                    newsType:id,
                    current:1,
                    pageSize:-1,
                    lang:1
                }
            )
            if(res.code==1) {
                this.media = res.data.records
                if(this.media.length >0) {
                    this.initMediaSwiper()
                }
            }
        },
        initMediaSwiper() {
            let mediaSwiper =  new Swiper('.media_bottom .swiper-container', {
                spaceBetween: this.isMobile ? 10 : 20,
                slidesPerView: this.isMobile ? 3 : 6,
                autoplay: 2000,
                speed: 2000,
                loop: this.isMobile ? this.media.length > 3 ? true : false:this.media.length > 6 ? true : false,
                autoplayDisableOnInteraction: false,
                observer: true,
            })
            //鼠标覆盖停止自动切换
            mediaSwiper.container[0].onmouseover=function(){
                mediaSwiper.stopAutoplay();
            }
            //鼠标移出开始自动切换
            mediaSwiper.container[0].onmouseout=function(){
                mediaSwiper.startAutoplay();
            }
        },
        goMore(num1,num2) {
            let type = num1
            let category = num2
            this.$router.push({ path: `/conference/list/${type}/${category}/1` })
        },
        goItemDetail(num1,item) {
            if(item.link) {
                window.open(item.link, '_blank');
            } else {
                let type = num1
                let category = item.newsType
                let id = item.id
                this.$router.push({ path: `/conference/details/news/${type}/${category}/${id}/1` })
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../node_modules/swiper/dist/css/swiper.css';
.conferenceIndex {
    .scroll {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        height: 56px;
        .scroll_left {
            height: 100%;
            width: 70%;
            padding: 0 30px;
            line-height: 40px;
            color: #0098dd;
            background: #f3f6fb;
            display: flex;
            align-items: center;
            border-radius: 6px;
            .scroll_left_img {
                display: flex;
                align-items: center;
                height: 100%;
                margin-right: 12px;
                img {
                    width: 22px;
                    height: 22px;
                }
            }
            .scrollingWords {
                height: 100%;
                flex-grow: 1;
                position: relative;
                overflow: hidden;
                display: flex;
                align-items: center;
                >div {
                    height: 100%;
                    line-height: 56px;
                    font-size: 18px;
                    color: #39A516;
                    white-space: nowrap;
                    position: absolute;
                    left: 100%;
                    bottom: 0;
                    transition: 0.3s ease color;
                }
            }
        }
        .scroll_right {
            height: 100%;
            line-height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            width: 28.3%;
            font-size: 18px;
            background: #ffffff;
            border: 1px solid #dadee6;
            color: #787878;
            .scroll_right_img {
                margin-right: 12px;
                img {
                    width: 22px;
                    height: 24px;
                }
            }
            span {
                color: #FF7E00;
                margin: 0 15px;
            }
        }
    }
    .meeting {
        margin-bottom: 60px;
        .meeting_box {
            display: flex;
            justify-content: space-between;
            .meeting_item {
                width: 570px;
                .meeting_item_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 20px 0;
                    .meeting_item_top_left {
                        display: flex;
                        align-items: center;
                        .meeting_item_top_left_line {
                            width: 6px;
                            height: 28px;
                            background: #0085d0;
                            border-radius: 3px;
                            margin-right: 13px;
                        }
                        .meeting_item_top_left_text {
                            font-size: 28px;
                            font-weight: bold;
                        }
                    }
                    .meeting_item_top_right {
                        display: flex;
                        align-items: center;
                        .meeting_item_top_right_line {
                            width: 34px;
                            height: 2px;
                            background: #0085d0;
                        }
                        .meeting_item_top_right_text {
                            font-size: 16px;
                            color: #787878;
                            margin:  013px;
                            cursor: pointer;
                        }
                        .meeting_item_top_right_img {
                            display: flex;
                            align-items: center;
                            img {
                                width: 7px;
                                height: 12px;
                            }
                        }
                    }
                }
                .meeting_left_bottom {
                    width: 100%;
                    height: 380px;
                    border-radius: 6px;
                    overflow: hidden;
                    .swiper-container {
                        height: 100%;
                        background: #efefef;
                        border: 1px solid transparent;
                        box-sizing: border-box;
                        overflow: hidden;
                        position: relative;
                        .swiper-wrapper {
                            height: 100%!important;
                            width: 100%!important;
                            .swiper-slide {
                                height: 100%!important;
                                width: 100%!important;
                                position: relative;
                                cursor: pointer;
                                .meeting_left_bottom_img {
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    img {
                                        width: 100%;
                                        height: 100%;
                                    }
                                    .none_img {
                                        max-width: 100%;
                                        max-height: 100%;
                                        object-fit: contain;
                                    }
                                }
                                .meeting_left_bottom_mask {
                                    width: 100%;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    height: 72px;
                                    border-bottom-left-radius: 6px;
                                    border-bottom-right-radius: 6px;
                                    background: rgba(0,0,0,0.5);
                                    color: #ffffff;
                                    font-size: 20px;
                                    display: flex;
                                    justify-content: space-between;
                                    .meeting_left_bottom_mask_name {
                                        padding: 0 20px;
                                        line-height: 72px;
                                        width: 80%;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 1;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                        text-align: center;
                                    }
                                }
                            }
                        }
                        .pagination_box{
                            position: absolute;
                            height: 72px;
                            bottom: 0;
                            right: 0;
                            width: 20%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            /deep/.swiper-pagination {
                                .swiper-pagination-bullet {
                                    height: 8px;
                                    width: 8px;
                                    background-color: #ffffff!important;
                                    opacity: 1;
                                    margin-right: 6px;
                                }
                                .swiper-pagination-bullet:last-child {
                                    margin-right: 0;
                                }
                                .swiper-pagination-bullet-active {
                                    background-color: #39A516!important;
                                }
                            }
                        }
                    }
                }
                .meeting_right_bottom {
                    height: 380px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding-top: 20px;
                    .meeting_right_bottom_profile {
                        font-size: 18px;
                        line-height: 2;
                        text-align: justify;
                    }
                    .meeting_right_bottom_box {
                        display: flex;
                        justify-content: space-between;
                        .meeting_right_bottom_box_item {
                            width: 178px;
                            height: 142px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            border-radius: 12px;
                            cursor: pointer;
                            // 渐变背景色从左上到右下
                            background: linear-gradient(to bottom right, #70bfff, #418bff);
                            .meeting_right_bottom_box_item_top {
                                width: 64px;
                                height: 64px;
                                margin-bottom: 8px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .meeting_right_bottom_box_item_bottom {
                                font-size: 24px;
                                color: #ffffff;
                                font-weight: bold;
                            }
                        }
                        .meeting_right_bottom_box_item:nth-child(2) {
                            background: linear-gradient(to bottom right, #56f2b3, #00cb8b);
                        }
                        .meeting_right_bottom_box_item:last-child {
                            background: linear-gradient(to bottom right, #ffcd54, #ffb228);
                        }
                    }
                }
            }
            .meeting_right {
                .meeting_item_top {
                    border-bottom: 1px solid #e8ebf3;
                }
            }
        }
    }
    .focus {
        margin-bottom: 80px;
        .focus_box {
            .meeting_item_top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0;
                .meeting_item_top_left {
                    display: flex;
                    align-items: center;
                    .meeting_item_top_left_line {
                        width: 6px;
                        height: 28px;
                        background: #0085d0;
                        border-radius: 3px;
                        margin-right: 13px;
                    }
                    .meeting_item_top_left_text {
                        font-size: 28px;
                        font-weight: bold;
                    }
                }
                .meeting_item_top_right {
                    display: flex;
                    align-items: center;
                    .meeting_item_top_right_line {
                        width: 34px;
                        height: 2px;
                        background: #0085d0;
                    }
                    .meeting_item_top_right_text {
                        font-size: 16px;
                        color: #787878;
                        margin:  013px;
                        cursor: pointer;
                    }
                    .meeting_item_top_right_img {
                        display: flex;
                        align-items: center;
                        img {
                            width: 7px;
                            height: 12px;
                        }
                    }
                }
            }
            .focus_bottom {
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            padding: 30px;
                            border: 1px solid #e8ebf3;
                            border-radius: 6px;
                            font-size: 18px;
                            cursor: pointer;
                            .focus_item_top {
                                font-size: 20px;
                                font-weight: bold;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                            .focus_item_time {
                                margin:15px 0 20px 0;
                                color: #787878;
                            }
                            .focus_item_profile {
                                height: 55px;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                color: #787878;
                                line-height: 1.5;
                            }
                            .focus_item_more {
                                margin-top: 20px;
                                font-size: 16px;
                                color: #0085D0;
                                cursor: pointer;
                            }
                        }
                        .swiper-slide:hover {
                            .focus_item_top {
                                color: #0085D0;
                                text-decoration: underline;
                                text-underline-offset: 3px;
                            }
                        }
                    }
                }
            }
        }
    }
    .notice {
        background-color: #f6f9fe;
        padding: 60px 0;
        .meeting_box {
            display: flex;
            justify-content: space-between;
            .meeting_left {
                width: calc(100% - 355px - 50px);
            }
            .meeting_right {
                width: 355px;
            }
            .meeting_item {
                .meeting_item_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 20px 0;
                    .meeting_item_top_left {
                        display: flex;
                        align-items: center;
                        .meeting_item_top_left_line {
                            width: 6px;
                            height: 28px;
                            background: #0085d0;
                            border-radius: 3px;
                            margin-right: 13px;
                        }
                        .meeting_item_top_left_text {
                            font-size: 28px;
                            font-weight: bold;
                        }
                    }
                    .meeting_item_top_right {
                        display: flex;
                        align-items: center;
                        .meeting_item_top_right_line {
                            width: 34px;
                            height: 2px;
                            background: #0085d0;
                        }
                        .meeting_item_top_right_text {
                            font-size: 16px;
                            color: #787878;
                            margin:  013px;
                            cursor: pointer;
                        }
                        .meeting_item_top_right_img {
                            display: flex;
                            align-items: center;
                            img {
                                width: 7px;
                                height: 12px;
                            }
                        }
                    }
                }
                .notice_left_bottom {
                    width: 100%;
                    height: 320px;
                    border-radius: 6px;
                    overflow: hidden;
                    .swiper-container {
                        width: 100%;
                        height: 100%;
                        box-sizing: border-box;
                        overflow: hidden;
                        position: relative;
                        .swiper-wrapper {
                            height: 100%!important;
                            width: 100%!important;
                            .swiper-slide {
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                height: 100%!important;
                                background-color: #ffffff;
                                padding: 30px 20px;
                                border-radius: 6px;
                                cursor: pointer;
                                .focus_item_top {
                                    .focus_item_top_title {
                                        font-size: 20px;
                                        line-height: 1.5;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                    }
                                    .focus_item_top_line {
                                        margin-top: 30px;
                                        border-bottom: 1px solid #F6F9FE;
                                    }
                                }
                                .focus_item_profile {
                                    font-size: 16px;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                    color: #787878;
                                    line-height: 1.8;
                                }
                                .focus_item_time {
                                    font-size: 16px;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    .focus_item_time_right {
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                        img {
                                            width: 20px;
                                            height: 20px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .meeting_right_bottom {
                    height: 320px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .meeting_right_bottom_box {
                        height: 100%;
                        .meeting_right_bottom_box_item {
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            padding-bottom: 25px;
                            margin-bottom: 25px;
                            border-bottom: 1px solid #E8EBF3;
                            .meeting_right_bottom_box_item_left {
                                width: 64px;
                                height: 64px;
                                background: #0085d0;
                                border-radius: 12px;
                                color: #ffffff;
                                margin-right: 10px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                .meeting_right_bottom_box_item_left_top {
                                    font-size: 24px;
                                    line-height: 1;
                                }
                                .meeting_right_bottom_box_item_left_bottom {
                                    font-size: 12px;
                                }
                            }
                            .meeting_right_bottom_box_item_right {
                                width: calc(100% - 64px - 10px);
                                font-size: 18px;
                                line-height: 1.5;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                        }
                        .meeting_right_bottom_box_item:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
    .middle {
        padding-bottom: 60px;
        position: relative;
        background-image: url('../assets/images/conference/con_items_bgc.png'); /* 背景图 */
        background-size: 100% 45%; /* 设置背景图的高度为盒子高度的一半 */
        background-position: center top; /* 将背景图的起始位置设置在盒子的顶部中央 */
        background-repeat: no-repeat; /* 防止背景图重复 */
        .middle_box {
            display: flex;
            box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
            .middle_item {
                width: 400px;
                height: 264px;
                padding: 30px 30px 40px 30px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .middle_item_top {
                    font-size: 28px;
                    font-weight: bold;
                    color: #ffffff;
                }
                .middle_item_line {
                    width: 56px;
                    height: 2px;
                    background: #ffffff;
                    border-radius: 1px;
                }
                .middle_item_profile {
                    font-size: 16px;
                    line-height: 2;
                    color: #D9E2E8;
                }
                .middle_item_more {
                    font-size: 16px;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    img {
                        margin-left: 10px;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
            .middle_item:nth-child(2) {
                .middle_item_top {
                    color: #000000;
                }
                .middle_item_line {
                    background: #0085D0;
                }
                .middle_item_profile {
                    color: #787878;
                }
                .middle_item_more {
                    color: #0085D0;
                }
            }
        }
    }
    .guest {
        padding: 0 0 60px 0;
        .guest_box {
            .guest_top {
                .meeting_item_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 20px 0;
                    .meeting_item_top_left {
                        display: flex;
                        align-items: center;
                        .meeting_item_top_left_line {
                            width: 6px;
                            height: 28px;
                            background: #0085d0;
                            border-radius: 3px;
                            margin-right: 13px;
                        }
                        .meeting_item_top_left_text {
                            font-size: 28px;
                            font-weight: bold;
                        }
                    }
                    .meeting_item_top_right {
                        display: flex;
                        align-items: center;
                        .meeting_item_top_right_line {
                            width: 34px;
                            height: 2px;
                            background: #0085d0;
                        }
                        .meeting_item_top_right_text {
                            font-size: 16px;
                            color: #787878;
                            margin:  013px;
                            cursor: pointer;
                        }
                        .meeting_item_top_right_img {
                            display: flex;
                            align-items: center;
                            img {
                                width: 7px;
                                height: 12px;
                            }
                        }
                    }
                }

            }
            .guest_bottom, .current_expert, .history_expert {
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            position: relative;
                            height: 295px;
                            cursor: pointer;
                            .guest_img {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 224px;
                                height: 224px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 12px;
                                }
                                .none_img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                    border-radius: 12px;
                                }
                            }
                            .guest_img_box {
                                width: 100%;
                                position: absolute;
                                top: 170px;
                                left: 0;
                                padding: 0 10px;
                                .guest_img_box_box {
                                    padding: 20px 18px;
                                    background: rgba(255, 255, 255,0.84);
                                    height: 125px;
                                    border-radius: 12px;
                                    .guest_img_box_box_top {
                                        display: flex;
                                        align-items: flex-end;
                                        margin-bottom: 10px;
                                        .guest_img_box_box_top_left {
                                            font-size: 20px;
                                            margin-right: 10px;
                                            font-weight: bold;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 1;
                                            -webkit-box-orient: vertical;
                                            overflow: hidden;
                                        }
                                        .guest_img_box_box_top_right {
                                            font-size: 14px;
                                            margin-bottom: 2px;
                                        }
                                    }
                                    .guest_img_box_box_bottom {
                                        font-size: 14px;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                        line-height: 1.5;
                                        color: #787878;
                                    }
                                }
                                .guest_img_box_box_bgc {
                                    background: rgba(246, 249, 254,0.84);
                                }
                            }
                        }
                        .swiper-slide:hover{
                            .guest_img_box {
                                .guest_img_box_box {
                                    background: rgba(0, 133, 208,0.84);
                                    .guest_img_box_box_top {
                                        color: #ffffff;
                                    }
                                    .guest_img_box_box_bottom {
                                        color: #ffffff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .expert {
        padding: 40px 0 60px 0;
        background-color: #f6f9fe;
        .guest_box {
            .guest_top {
                margin-bottom: 20px;
                border-bottom: 1px solid #e8ebf3;
                .meeting_item_top {
                    .meeting_item_top_left_text {
                        font-weight: normal!important;
                        cursor: pointer;
                        position: relative;
                    }
                    .meeting_item_top_left_text_active {
                        font-weight: bold!important;
                        .meeting_item_top_left_text_line {
                            // width: 164px;
                            height: 5px;
                            background: #0085d0;
                            border-radius: 2px;
                            position: absolute;
                            height: 5px;
                            width: 75%;
                            top: 110%;
                            left: 50%;
                            transform: translate(-50%,17.5px);
                        }
                    }
                }
            }
        }
    }
    .sponsor {
        padding: 40px 0 60px 0;
        .guest_box {
            .guest_top {
                .meeting_item_top {
                    .meeting_item_top_left {
                        .meeting_item_top_left_text {
                            display: flex;
                            .meeting_item_top_left_text_right {
                                font-size: 18px;
                                font-weight: 400;
                                margin-top: 12px;
                            }
                        }
                    }
                }
            }
            .sponsor_bottom {
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            border-radius: 12px;
                            overflow: hidden;
                            cursor: pointer;
                            .sponsor_img {
                                width: 183px;
                                height: 104px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                border: 1px solid #eef1f6;
                                border-radius: 12px;
                                box-shadow: -4px 0px 8px 4px rgba(0,0,0,0.04); 
                                img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .media {
        padding: 0 0 60px 0;
        .guest_box {
            .guest_top {
                .meeting_item_top {
                    .meeting_item_top_left {
                        .meeting_item_top_left_text {
                            display: flex;
                            .meeting_item_top_left_text_right {
                                font-size: 18px;
                                font-weight: 400;
                                margin-top: 12px;
                            }
                        }
                    }
                }
            }
            .media_bottom {
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            border-radius: 12px;
                            overflow: hidden;
                            cursor: pointer;
                            .media_img {
                                width: 183px;
                                height: 104px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                border: 1px solid #eef1f6;
                                border-radius: 12px;
                                box-shadow: -4px 0px 8px 4px rgba(0,0,0,0.04); 
                                img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .conferenceIndex {
        .scroll {
            flex-direction: column;
            margin-top: 0.2rem;
            height: auto;
            .scroll_left {
                height: 1rem;
                width: 100%;
                padding: 0 0.2rem;
                line-height: 1rem;
                border-radius: 0.1rem;
                .scroll_left_img {
                    height: 100%;
                    margin-right: 0.2rem;
                    img {
                        width: 0.4rem;
                        height: 0.4rem;
                    }
                }
                .scrollingWords {
                    >div {
                        line-height: 1rem;
                        font-size: 0.32rem;
                    }
                }
            }
            .scroll_right {
                margin-top: .2rem;
                width: 100%;
                height: 1rem;
                line-height: 1rem;
                border-radius: 0.1rem;
                font-size: 0.32rem;
                .scroll_right_img {
                    margin-right: 0.2rem;
                    img {
                        width: 0.4rem;
                        height: 0.4rem;
                    }
                }
                span {
                    margin: 0 0.2rem;
                }
            }
        }
        .meeting {
            margin-bottom: 0.6rem;
            .meeting_box {
                flex-direction: column;
                .meeting_item {
                    width: 100%;
                    .meeting_item_top {
                        padding: 0.3rem 0;
                        .meeting_item_top_left {
                            .meeting_item_top_left_line {
                                width: 0.08rem;
                                height: 0.45rem;
                                border-radius: 0.06rem;
                                margin-right: 0.15rem;
                            }
                            .meeting_item_top_left_text {
                                font-size: 0.4rem;
                            }
                        }
                        .meeting_item_top_right {
                            .meeting_item_top_right_line {
                                width: 0.6rem;
                                height: 0.04rem;
                            }
                            .meeting_item_top_right_text {
                                font-size: 0.3rem;
                                margin: 0 0.15rem;
                            }
                            .meeting_item_top_right_img {
                                img {
                                    width: 0.12rem;
                                    height: 0.2rem;
                                }
                            }
                        }
                    }
                    .meeting_left_bottom {
                        width: 100%;
                        height: 5rem;
                        border-radius: 0.12rem;
                        .swiper-container {
                            .swiper-wrapper {
                                .swiper-slide {
                                    .meeting_left_bottom_mask {
                                        height: 1rem;
                                        border-bottom-left-radius: 0.12rem;
                                        border-bottom-right-radius: 0.12rem;
                                        font-size: 0.3rem;
                                        .meeting_left_bottom_mask_name {
                                            padding: 0 0.2rem;
                                            line-height: 1rem;
                                            width: 75%;
                                        }
                                    }
                                }
                            }
                            .pagination_box{
                                height: 1rem;
                                width: 25%;
                                /deep/.swiper-pagination {
                                    .swiper-pagination-bullet {
                                        height: 0.14rem;
                                        width: 0.14rem;
                                        margin-right: 0.12rem;
                                    }
                                }
                            }
                        }
                    }
                    .meeting_right_bottom {
                        height: auto;
                        padding-top: 0.2rem;
                        .meeting_right_bottom_profile {
                            font-size: 0.3rem;
                            line-height:1.6;
                            margin-bottom: 0.2rem;
                        }
                        .meeting_right_bottom_box {
                            .meeting_right_bottom_box_item {
                                width: 31.5%;
                                height: 1.8rem;
                                border-radius: 0.2rem;
                                .meeting_right_bottom_box_item_top {
                                    width: 0.8rem;
                                    height: 0.8rem;
                                    margin-bottom: 0.1rem;
                                    img {
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                                .meeting_right_bottom_box_item_bottom {
                                    font-size: 0.3rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .focus {
            margin-bottom: 0.6rem;
            .focus_box {
                .meeting_item_top {
                        padding: 0.3rem 0;
                        .meeting_item_top_left {
                            .meeting_item_top_left_line {
                                width: 0.08rem;
                                height: 0.45rem;
                                border-radius: 0.06rem;
                                margin-right: 0.15rem;
                            }
                            .meeting_item_top_left_text {
                                font-size: 0.4rem;
                            }
                        }
                        .meeting_item_top_right {
                            .meeting_item_top_right_line {
                                width: 0.6rem;
                                height: 0.04rem;
                            }
                            .meeting_item_top_right_text {
                                font-size: 0.3rem;
                                margin: 0 0.15rem;
                            }
                            .meeting_item_top_right_img {
                                img {
                                    width: 0.12rem;
                                    height: 0.2rem;
                                }
                            }
                        }
                    }
                .focus_bottom {
                    .swiper-container {
                        .swiper-wrapper {
                            .swiper-slide {
                                padding: 0.2rem;
                                border-radius: 0.12rem;
                                font-size: 0.26rem;
                                .focus_item_top {
                                    font-size: 0.3rem;
                                }
                                .focus_item_time {
                                    margin:0.2rem 0 0.2rem 0;
                                }
                                .focus_item_profile {
                                    font-size: 0.28rem;
                                    height: 0.9rem;
                                    line-height: 1.6;
                                }
                                .focus_item_more {
                                    margin-top: 0.2rem;
                                    font-size: 0.28rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .notice {
            padding: 0.6rem 0;
            .meeting_box {
                flex-direction: column;
                .meeting_left {
                    width: 100%;
                }
                .meeting_right {
                    width: 100%;
                    margin-top: 0.2rem;
                }
                .meeting_item {
                    .meeting_item_top {
                        padding: 0.3rem 0;
                        .meeting_item_top_left {
                            .meeting_item_top_left_line {
                                width: 0.08rem;
                                height: 0.45rem;
                                border-radius: 0.06rem;
                                margin-right: 0.15rem;
                            }
                            .meeting_item_top_left_text {
                                font-size: 0.4rem;
                            }
                        }
                        .meeting_item_top_right {
                            .meeting_item_top_right_line {
                                width: 0.6rem;
                                height: 0.04rem;
                            }
                            .meeting_item_top_right_text {
                                font-size: 0.3rem;
                                margin: 0 0.15rem;
                            }
                            .meeting_item_top_right_img {
                                img {
                                    width: 0.12rem;
                                    height: 0.2rem;
                                }
                            }
                        }
                    }
                    .notice_left_bottom {
                        width: 100%;
                        height: auto;
                        border-radius: 0.12rem;
                        .swiper-container {
                            .swiper-wrapper {
                                .swiper-slide {
                                    padding: 0.2rem 0.2rem;
                                    border-radius: 0.12rem;
                                    .focus_item_top {
                                        .focus_item_top_title {
                                            font-size: 0.3rem;
                                            line-height: 1.5;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 1;
                                            -webkit-box-orient: vertical;
                                            overflow: hidden;
                                        }
                                        .focus_item_top_line {
                                            margin-top: 0.2rem;
                                        }
                                    }
                                    .focus_item_profile {
                                        height: 0.9rem;
                                        font-size: 0.28rem;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        overflow: hidden;
                                        color: #787878;
                                        line-height: 1.6;
                                        margin: 0.2rem 0;
                                    }
                                    .focus_item_time {
                                        font-size: 0.26rem;
                                        .focus_item_time_right {
                                            img {
                                                width: 0.4rem;
                                                height: 0.4rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .meeting_right_bottom {
                        height: auto;
                        .meeting_right_bottom_box {
                            height: 100%;
                            .meeting_right_bottom_box_item {
                                padding-bottom: 0.3rem;
                                margin-bottom: 0.3rem;
                                .meeting_right_bottom_box_item_left {
                                    width: 1.2rem;
                                    height: 1.2rem;
                                    border-radius: 0.2rem;
                                    margin-right: 0.2rem;
                                    .meeting_right_bottom_box_item_left_top {
                                        font-size: 0.4rem;
                                    }
                                    .meeting_right_bottom_box_item_left_bottom {
                                        font-size: 0.24rem;
                                    }
                                }
                                .meeting_right_bottom_box_item_right {
                                    width: calc(100% - 1.2rem - 0.2rem);
                                    font-size: 0.3rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .middle {
            padding-bottom: 0.6rem;
            position: relative;
            background-image: url('../assets/images/conference/con_items_bgc.png'); /* 背景图 */
            background-size: 100% 45%; /* 设置背景图的高度为盒子高度的一半 */
            background-position: center center; /* 将背景图的起始位置设置在盒子的顶部中央 */
            background-repeat: repeat;
            .middle_box {
                flex-direction: column;
                box-shadow:none;
                .middle_item {
                    width: 100%;
                    height: auto;
                    padding: 0.4rem 0.3rem 0.5rem 0.3rem;
                    background-size: 100% 100%;
                    border-radius: 0.3rem;
                    margin-bottom: 0.2rem;
                    box-shadow: 0px 0px 14px 0px rgba(29, 47, 71, 0.14);
                    .middle_item_top {
                        font-size: 0.4rem;
                    }
                    .middle_item_line {
                        width: 0.8rem;
                        height: 0.04rem;
                        margin: 0.4rem 0;
                    }
                    .middle_item_profile {
                        font-size: 0.28rem;
                        line-height: 1.8;
                        margin-bottom: 0.4rem;
                    }
                    .middle_item_more {
                        font-size: 0.28rem;
                        img {
                            margin-left: 0.2rem;
                            width: 0.35rem;
                            height: 0.35rem;
                        }
                    }
                }
                .middle_item:nth-child(3) {
                    margin-bottom: 0;
                }
            }
        }
        .guest {
            padding: 0 0 0.6rem 0;
            .guest_box {
                .guest_top {
                    .meeting_item_top {
                        padding: 0.3rem 0;
                        .meeting_item_top_left {
                            .meeting_item_top_left_line {
                                width: 0.08rem;
                                height: 0.45rem;
                                border-radius: 0.06rem;
                                margin-right: 0.15rem;
                            }
                            .meeting_item_top_left_text {
                                font-size: 0.4rem;
                            }
                        }
                        .meeting_item_top_right {
                            .meeting_item_top_right_line {
                                width: 0.6rem;
                                height: 0.04rem;
                            }
                            .meeting_item_top_right_text {
                                font-size: 0.3rem;
                                margin: 0 0.15rem;
                            }
                            .meeting_item_top_right_img {
                                img {
                                    width: 0.12rem;
                                    height: 0.2rem;
                                }
                            }
                        }
                    }
                }
                .guest_bottom, .current_expert, .history_expert {
                    .swiper-container {
                        .swiper-wrapper {
                            .swiper-slide {
                                height: 4.4rem;
                                display: flex;
                                justify-content: center;
                                .guest_img {
                                    width: 3rem;
                                    height: 3rem;
                                    img {
                                        border-radius: 0.15rem;
                                    }
                                    .none_img {
                                        border-radius: 0.15rem;
                                    }
                                }
                                .guest_img_box {
                                    width: 85%;
                                    position: absolute;
                                    top: 2.2rem;
                                    left: 50%;
                                    transform: translate(-50%);
                                    padding: 0 0.1rem;
                                    display: flex;
                                    justify-content: center;
                                    .guest_img_box_box {
                                        width: 100%;
                                        padding: 0.2rem 0.2rem;
                                        background: rgba(246, 249, 254,0.84);
                                        height: 2.2rem;
                                        border-radius: 0.15rem;
                                        .guest_img_box_box_top {
                                            display: flex;
                                            flex-direction: column;
                                            align-items: flex-start;
                                            margin-bottom: 0.1rem;
                                            .guest_img_box_box_top_left {
                                                font-size: 0.3rem;
                                                margin-right: 0;
                                                margin-bottom: 0.05rem;
                                            }
                                            .guest_img_box_box_top_right {
                                                font-size: 0.28rem;
                                                margin-bottom: 0;
                                            }
                                        }
                                        .guest_img_box_box_bottom {
                                            font-size: 0.28rem;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .expert {
            padding: 0.2rem 0 0.6rem 0;
            background-color: #f6f9fe;
            .guest_box {
                .guest_top {
                    margin-bottom: 0.4rem;
                    border-bottom: 1px solid #e8ebf3;
                    .meeting_item_top {
                        .meeting_item_top_left {
                            .meeting_item_top_left_text {
                                width: 2rem;
                                text-align: center;
                            }
                            .meeting_item_top_left_text_active {
                                .meeting_item_top_left_text_line {
                                    height: 0.07rem;
                                    border-radius: 0.04rem;
                                    width: 70%;
                                    top: 100%;
                                    left: 50%;
                                    transform: translate(-50%,0.27rem);
                                }
                            }
                            .meeting_item_top_left_text:first-child {
                                margin-right: 0.3rem!important;
                            }
                        }
                    }
                }
                .current_expert, .history_expert {
                    .swiper-container {
                        .swiper-wrapper {
                            .swiper-slide {
                                .guest_img_box {
                                    .guest_img_box_box {
                                        background: rgba(255, 255, 255,0.84);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .sponsor {
            padding: 0.2rem 0 0.6rem 0;
            .guest_box {
                .guest_top {
                    .meeting_item_top {
                        .meeting_item_top_left {
                            .meeting_item_top_left_text {
                                .meeting_item_top_left_text_right {
                                    font-size: 0.28rem;
                                    margin-top: 0.1rem;
                                }
                            }
                        }
                    }
                }
                .sponsor_bottom {
                    .swiper-container {
                        .swiper-wrapper {
                            .swiper-slide {
                                border-radius: 0.12rem;
                                .sponsor_img {
                                    width: 100%;
                                    height: 1.36rem;
                                    border-radius: 0.12rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .media {
            padding: 0 0 0.6rem 0;
            .guest_box {
                .guest_top {
                    .meeting_item_top {
                        .meeting_item_top_left {
                            .meeting_item_top_left_text {
                                .meeting_item_top_left_text_right {
                                    font-size: 0.28rem;
                                    margin-top: 0.1rem;
                                }
                            }
                        }
                    }
                }
                .media_bottom {
                    .swiper-container {
                        .swiper-wrapper {
                            .swiper-slide {
                                border-radius: 0.12rem;
                                .media_img {
                                    width: 100%;
                                    height: 1.36rem;
                                    border-radius: 0.12rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>